// extracted by mini-css-extract-plugin
export default {"undoButton":"UndoButton_undoButton__--01x","icon":"UndoButton_icon__9C6Zi","iconRotate":"UndoButton_iconRotate__jIV++","spinIcon":"UndoButton_spinIcon__aXDCv"};